import { useDaily } from '@daily-co/daily-react';
import { useCallback } from 'react';
import type { RecorderCommand } from '~/common/recorder/recorder-operation';
import { useAtomValue } from 'jotai';
import { wdioSocketAtom } from '~/atoms/recorder-atoms';

// You probably want to use the method in the useVm hook instead (it does more) but this is easier to pass around
export const useSendVmCommand = () => {
  const wdioSocket = useAtomValue(wdioSocketAtom);
  const daily = useDaily();

  const sendServerCommand = useCallback(
    (command: RecorderCommand) => {
      try {
        if (!wdioSocket) {
          throw new Error('No socket');
        }
        wdioSocket.send(JSON.stringify(command));
      } catch (e) {
        // ignore
      }

      const meetingState = daily?.meetingState();
      // We ensure the meeting state is joined otherwise daily console.errors intenrally (we want to avoid this spam)
      if (meetingState === 'joined-meeting') {
        try {
          daily?.sendAppMessage(JSON.stringify(command));
        } catch (e) {
          // ignore
        }
      }
    },
    [daily, wdioSocket],
  );

  return sendServerCommand;
};
